export * from './app.module';



// WEBPACK FOOTER //
// /ng-app/src/app/index.ts